import React from 'react';
import Switch from 'react-switch';
import { PlatformHeader } from './header';
import './ChatHeader.css';
import FilterPromptGenerator from './FilterComponent';

const ChatHeader: React.FC<{
  isCompleteEnabled: boolean;
  setIsCompleteEnabled: (value: boolean) => void;
  isOnySQLEnabled: boolean;
  setIsOnySQLEnabled: (value: boolean) => void;
  columns: any;
  setFilter: any;
}> = ({
  isCompleteEnabled,
  setIsCompleteEnabled,
  isOnySQLEnabled,
  setIsOnySQLEnabled,
  columns,
  setFilter,
}) => {
  return (
    <>
      <div className="chat-header">
        <div className="switches-container">
          <label
            className="switch-label"
            data-tooltip="Allow LLM directly answers on data."
          >
            <span>Smart Insights</span>
            <Switch
              onChange={() => setIsCompleteEnabled(!isCompleteEnabled)}
              checked={isCompleteEnabled}
              onColor="#90ee90"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              height={20}
              width={48}
            />
          </label>
          <label className="switch-label" data-tooltip="Generates only SQL">
            <span>Generate SQL</span>
            <Switch
              onChange={() => setIsOnySQLEnabled(!isOnySQLEnabled)}
              checked={isOnySQLEnabled}
              onColor="#90ee90"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              height={20}
              width={48}
            />
          </label>
          {/* <FilterPromptGenerator columnOptions={columns} setFilter={setFilter} />  */}
        </div>
      </div>
    </>
  );
};

export default ChatHeader;
